import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'contexts';

interface Props {
    eventAlias?: string;
}

export function NavDrawer({ eventAlias }: Props) {
    const navigate = useNavigate();
    const user = useUserContext();
    const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setIsDrawerOpen(open);
    };

    const handleNavigate = (path: string) => {
        if (eventAlias) {
            console.log('navigate to ', `/${eventAlias}${path}`);
            navigate(`/${eventAlias}${path}`);
            return;
        }
        console.log('navigate to ', path);
        navigate(path);
    };

    const list = (
        <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)}>
            <List sx={{ width: '100%' }}>
                <ListItem key="nav-list-quizzes" disablePadding onClick={() => handleNavigate('/quiz-selector')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="Quiz List" />
                    </ListItemButton>
                </ListItem>
                {user.isSuperAdmin() && !eventAlias && (
                    <ListItem key="nav-list-root-quizzes" disablePadding onClick={() => handleNavigate('/root-quiz-selector')}>
                        <ListItemButton>
                            <ListItemIcon>
                                <ListAltIcon />
                            </ListItemIcon>
                            <ListItemText primary="Root Quiz List" />
                        </ListItemButton>
                    </ListItem>
                )}
                <ListItem key="nav-my-quizzes" disablePadding>
                    <ListItemButton disabled={true}>
                        <ListItemIcon>
                            <BadgeIcon />
                        </ListItemIcon>
                        <ListItemText primary="My Quizzes" />
                    </ListItemButton>
                </ListItem>
                {user.isEventCreatorRole(eventAlias) && (
                    <ListItem key="nav-create-quiz" disablePadding onClick={() => handleNavigate('/quiz/create')}>
                        <ListItemButton>
                            <ListItemIcon>
                                <AddCircleIcon />
                            </ListItemIcon>
                            <ListItemText primary="Create Quiz" />
                        </ListItemButton>
                    </ListItem>
                )}
            </List>
            <Divider />
            <List sx={{ width: '100%' }}>
                <ListItem key="nav-profile" disablePadding onClick={() => handleNavigate('/profile')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <AccountCircleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Profile" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <div>
            <IconButton size="large" edge="start" color="inherit" aria-label="open drawer" sx={{ mr: 2 }} onClick={toggleDrawer(true)}>
                <MenuIcon />
            </IconButton>
            <SwipeableDrawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
                {list}
            </SwipeableDrawer>
        </div>
    );
}
